export default {
  isFavorite (object) {
    return this.$store.state.favorites.includes(object.id)
  },

  sortedObjectImages (objectImages) {
    if (!objectImages) { return []}
    return JSON.parse(JSON.stringify(objectImages)).sort((a, b) => {
      return parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
    })
  },
}
